import { useTranslation } from "react-i18next";

import Button from "@/components/buttons/Button";
import SuccessIcon from "@/components/icons/IconSuccess";

import useModalRouter from "@/hooks/useModalRouter";

const ForgotPasswordSuccess = () => {
  const { closeModal } = useModalRouter();
  const { t } = useTranslation();

  return (
    <div className="relative pt-10">
      <SuccessIcon className="absolute left-[50%] top-[-30%] z-[1000] translate-x-[-50%]" />
      <h2 className={"mb-4 text-center text-4xl"}>{t("Success.title")}</h2>
      <p className="mb-6 text-center text-[#919090]">{t("Success.pwd_reset_message")} </p>
      <Button onClick={closeModal}>{t("Actions.continue")}</Button>
    </div>
  );
};

export default ForgotPasswordSuccess;
